import { REASONING_EFFORTS, USER_ROLES } from './constants.js';
/** Chat features an administrator can switch on or off for one role. */
export const ROLE_FEATURE_KEYS = [
    'webSearch',
    'attachments',
    'shareLinks',
    'temporaryChat',
    'branching',
    'projects',
    'memory',
    'artifacts',
    'accountDeletion',
];
const ALL_FEATURES = {
    webSearch: true,
    attachments: true,
    shareLinks: true,
    temporaryChat: true,
    branching: true,
    projects: true,
    memory: true,
    artifacts: true,
    // Off for every role until an administrator turns it on (v0.10).
    accountDeletion: false,
    reasoningEfforts: [...REASONING_EFFORTS],
};
/**
 * Built-in values, matching the rules that were fixed in code before they were
 * configurable: restricted accounts cannot upload, share or start temporary
 * chats; every other role can use everything the instance offers. Projects
 * arrived later and follow the same line: off for restricted accounts until an
 * administrator turns them on. So do user memory and artifacts (v0.9); user
 * memory is also off instance-wide until an administrator turns it on.
 * Deleting one's own account (v0.10) is off for every role.
 */
export const DEFAULT_ROLE_FEATURES = Object.fromEntries(USER_ROLES.map((role) => [
    role,
    role === 'restricted'
        ? {
            ...ALL_FEATURES,
            attachments: false,
            shareLinks: false,
            temporaryChat: false,
            projects: false,
            memory: false,
            artifacts: false,
            reasoningEfforts: [...REASONING_EFFORTS],
        }
        : { ...ALL_FEATURES, reasoningEfforts: [...REASONING_EFFORTS] },
]));
/**
 * Puts allowed levels in canonical order, drops unknown or repeated values and
 * always keeps `instant`: switching reasoning off can never be withheld.
 */
export function normalizeReasoningEfforts(efforts) {
    return REASONING_EFFORTS.filter((effort) => effort === 'instant' || efforts.includes(effort));
}
/** The levels a model offers that a role is also allowed to choose. */
export function intersectReasoningEfforts(modelEfforts, roleEfforts) {
    return modelEfforts.filter((effort) => roleEfforts.includes(effort));
}
/**
 * The level a new conversation starts at: the administrator's default when the
 * model and role allow it, otherwise `instant`, otherwise the lowest offered.
 */
export function clampReasoningEffort(preferred, supported) {
    if (supported.length === 0)
        return 'instant';
    if (supported.includes(preferred))
        return preferred;
    return supported.includes('instant') ? 'instant' : (supported[0] ?? 'instant');
}
//# sourceMappingURL=role-features.js.map